// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.maintenance-content {
  background: white;
  border-radius: 12px;
  padding: 60px 40px;
  max-width: 600px;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
}

.maintenance-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

.maintenance-title {
  font-size: 28px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  font-family: 'MaerskHeadline', Arial, sans-serif;
}

.maintenance-message {
  font-size: 18px;
  color: #34495e;
  margin-bottom: 15px;
  line-height: 1.6;
}

.maintenance-submessage {
  font-size: 16px;
  color: #7f8c8d;
  margin-bottom: 30px;
  line-height: 1.5;
}

.maintenance-footer {
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #ecf0f1;
}

.maintenance-footer p {
  font-size: 14px;
  color: #95a5a6;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/MaintenancePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX","sourcesContent":[".maintenance-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  padding: 20px;\n}\n\n.maintenance-content {\n  background: white;\n  border-radius: 12px;\n  padding: 60px 40px;\n  max-width: 600px;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n}\n\n.maintenance-icon {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.05);\n    opacity: 0.8;\n  }\n}\n\n.maintenance-title {\n  font-size: 28px;\n  font-weight: 600;\n  color: #2c3e50;\n  margin-bottom: 20px;\n  font-family: 'MaerskHeadline', Arial, sans-serif;\n}\n\n.maintenance-message {\n  font-size: 18px;\n  color: #34495e;\n  margin-bottom: 15px;\n  line-height: 1.6;\n}\n\n.maintenance-submessage {\n  font-size: 16px;\n  color: #7f8c8d;\n  margin-bottom: 30px;\n  line-height: 1.5;\n}\n\n.maintenance-footer {\n  margin-top: 40px;\n  padding-top: 30px;\n  border-top: 1px solid #ecf0f1;\n}\n\n.maintenance-footer p {\n  font-size: 14px;\n  color: #95a5a6;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
